import React, { Component} from "react";
import { Button, UncontrolledTooltip
} from "reactstrap";
import { HiTrash, HiOutlineDocumentText, HiMiniTableCells } from "react-icons/hi2";
import { HiOutlineSwitchHorizontal } from "react-icons/hi";
import { LuCopyPlus, LuSettings, LuDownload, LuLayers, LuUpload, LuEye, LuChartBar } from "react-icons/lu";
import { GrTableAdd } from "react-icons/gr";
import { MdTableChart, MdPieChart } from "react-icons/md";
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";

import { IconContext } from "react-icons";
    
type State = {            
}

type Props = {
    size: string,
    tttext: string,  
    ariaLabel:string,
    text: string,
    disabled: boolean,
    onClick: () => void,
    type: string,
    color: string,
    id: string,
    className: string;
}

export class ImgButton extends Component<Props, State> {
    
    static defaultProps = {
        size: "sm",               
        tttext: "",
        ariaLabel: "",
        text:"",
        color: "primary",
        id: "",
        className: "",
        disabled: false
    }

    state: State = {
        
         
    }

    

    render() {  
        var img = <HiTrash />;
        if ( this.props.type === "del" )
            img = <HiTrash />;
        else if (this.props.type === "copy")
            img = <LuCopyPlus />;
        else if (this.props.type === "text")
            img = <HiOutlineDocumentText />;
        else if (this.props.type === "settings")
            img = <LuSettings />;
        else if (this.props.type === "download")
            img = <LuDownload />;
        else if (this.props.type === "upload")
            img = <LuUpload />;
        else if (this.props.type === "data")
            img = <HiMiniTableCells />;
        else if (this.props.type === "assign")
            img = <GrTableAdd />;
        else if (this.props.type === "layer")
            img = <LuLayers />;
        else if (this.props.type === "preview")
            img = <LuEye />;
        else if (this.props.type === "aereachart")
            img = <MdTableChart />;
        else if (this.props.type === "piechart")
            img = <MdPieChart />;
        else if (this.props.type === "barcharthor")
            img = <LuChartBar />;
        else if (this.props.type === "switch")
            img = <HiOutlineSwitchHorizontal />;
        else if (this.props.type == "toleft")
            img = <BiLeftArrowAlt />;
        else if (this.props.type == "toright")
            img = <BiRightArrowAlt />;
            
        if (this.props.tttext.length > 0 && this.props.id.length > 0) {
            
            return (
                <>
                    <Button aria-label={this.props.ariaLabel.length > 0 ? this.props.ariaLabel : this.props.tttext}   className={this.props.className} id={this.props.id} size={this.props.size} color={this.props.color} disabled={this.props.disabled} onClick={this.props.onClick}>{img}{this.props.text.length ? " " + this.props.text : ""}</Button>

                    <UncontrolledTooltip
                        placement='right'
                        target={this.props.id}>
                        {this.props.tttext}
                    </UncontrolledTooltip>

                    
                </>
            );
        }        
        else
            return <Button aria-label={this.props.ariaLabel.length > 0 ? this.props.ariaLabel  : this.props.text} className={this.props.className}  size={this.props.size} color={this.props.color} disabled={this.props.disabled}  onClick={this.props.onClick}><IconContext.Provider value={{}}>{img}</IconContext.Provider>{this.props.text.length ? " " + this.props.text : ""}</Button>
    }
}
